import React from 'react'
import './Style/MainDash.css'
import Cards from './Cards/Cards'
import LineChart from './LineChart'
import Header from './Header'
import Table from './Table/Table'



const MainDash = () => {
  return (
    <div className='maindash'>
          <Header/>
          <Cards/>
        <LineChart/>
        <Table/>
     
    </div>
  )
}

export default MainDash